export class Permissao {
  public Id: number;
  public Descricao: string;
  public Regra : string;
  public Grupo: boolean;
  public Perfis: [];
  public existe: boolean = false;

}
